import { render, staticRenderFns } from "./highTaskOngoing.vue?vue&type=template&id=1db1f16a&scoped=true&"
import script from "./highTaskOngoing.vue?vue&type=script&lang=js&"
export * from "./highTaskOngoing.vue?vue&type=script&lang=js&"
import style0 from "./highTaskOngoing.vue?vue&type=style&index=0&id=1db1f16a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db1f16a",
  null
  
)

export default component.exports